import React from 'react';
import { useTheme } from '../features/theme/context/ThemeContext';
import midusFullTightBlack from '../assets/midus_full_tight_black.svg';
import midusFullTightWhite from '../assets/midus_full_tight_white.svg';

/**
 * Full-screen auth checking loader.
 * Centered spinner with Midus logo in footer.
 * Use during auth state transitions to prevent UI glitching.
 */
const AuthLoader = ({ message }) => {
  const { darkMode } = useTheme();

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col bg-white dark:bg-[#111111]">
      {/* Centered spinner */}
      <div className="flex-1 flex flex-col items-center justify-center gap-3">
        <div
          className="w-12 h-12 border-2 border-t-transparent rounded-full animate-spin"
          style={{
            borderColor: darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)',
            borderTopColor: darkMode ? '#fff' : '#000',
          }}
        />
        {message && (
          <p
            className="text-sm"
            style={{
              color: darkMode ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.45)',
            }}
          >
            {message}
          </p>
        )}
      </div>

      {/* Footer with Midus logo */}
      <footer className="flex-shrink-0 pb-12 flex justify-center">
        <img
          src={darkMode ? midusFullTightWhite : midusFullTightBlack}
          alt="Midus"
          className="h-5 opacity-40"
          style={{ filter: 'grayscale(1)' }}
        />
      </footer>
    </div>
  );
};

export default AuthLoader;
